import { render, staticRenderFns } from "./biu-table.vue?vue&type=template&id=f5500eb0&"
import script from "./biu-table.vue?vue&type=script&lang=tsx&"
export * from "./biu-table.vue?vue&type=script&lang=tsx&"
import style0 from "./biu-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports